import type { AlteracaoDaConta } from "@base/contracts";
import { EstadoVazio, cn } from "@base/ui";
import { frase, rotuloDeDiaMes } from "./textos";

const SELO = {
  "nao-identificada": {
    rotulo: () => "Não identificada",
    classe: "bg-destructive/12 text-destructive",
  },
  aprendizado: {
    rotulo: (ate: string | null) => (ate ? `Em aprendizado até ${rotuloDeDiaMes(ate)}` : "Em aprendizado"),
    classe: "bg-warning/15 text-warning-foreground",
  },
  autorizada: {
    rotulo: () => "Autorizada",
    classe: "bg-muted text-muted-foreground",
  },
} as const;

function seloDe(alteracao: AlteracaoDaConta): { rotulo: string; classe: string } {
  if (alteracao.classificacao === "nao-identificada") {
    return { rotulo: SELO["nao-identificada"].rotulo(), classe: SELO["nao-identificada"].classe };
  }
  if (alteracao.classificacao === "aprendizado" || alteracao.aprendizadoAte) {
    return { rotulo: SELO.aprendizado.rotulo(alteracao.aprendizadoAte), classe: SELO.aprendizado.classe };
  }
  return { rotulo: SELO.autorizada.rotulo(), classe: SELO.autorizada.classe };
}

/** Alterações da conta, da mais recente para a mais antiga. Um selo só, no tom do PDF. */
export function LinhaDoTempo({ alteracoes }: { readonly alteracoes: readonly AlteracaoDaConta[] }) {
  if (alteracoes.length === 0) {
    return <EstadoVazio titulo="Nenhuma alteração registrada." descricao="Nada mudou nesta conta no período." />;
  }
  return (
    <div className="flex flex-col gap-3.5">
      <ul className="flex flex-col gap-3.5">
        {alteracoes.map((alteracao) => {
          const selo = seloDe(alteracao);
          return (
            <li
              key={`${alteracao.data}|${alteracao.classificacao}|${alteracao.descricao}`}
              className="flex flex-col gap-1 border-b border-border/60 pb-3.5 last:border-b-0 last:pb-0"
            >
              <div className="flex flex-wrap items-center gap-2">
                <time dateTime={alteracao.data} className="text-[13px] font-semibold tabular-nums text-muted-foreground">
                  {rotuloDeDiaMes(alteracao.data)}
                </time>
                <span className={cn("rounded-full px-2.5 py-0.5 text-xs font-semibold", selo.classe)}>{selo.rotulo}</span>
              </div>
              <span className="break-words text-sm text-foreground">
                {frase(alteracao.descricao)}
                {alteracao.repeticoes && alteracao.repeticoes > 1 ? (
                  <span className="ml-2 text-xs font-semibold text-muted-foreground">×{alteracao.repeticoes}</span>
                ) : null}
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
